import template from './router.html';
import './router.scss';

class RouterController {
  constructor(appResizableScreen) {
    'ngInject';

    this.appResizableScreen = appResizableScreen;
  }
  $onInit() {
    this.appResizableScreen.start();
  }
  $onDestroy() {
    this.appResizableScreen.stop();
  }
}

export default {
  controller: RouterController,
  template,
  transclude: true,
};
